import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from '@containers/payment/index.module.scss'
import { urlParamsToObj } from '@helpers/index'
import CardConnectWidget from '../utility/CardConnectWidget'
import StripeWidget from '../utility/StripeWidget.jsx'
import { withElements } from '@containers/payment/utility/stripe'
import config from '@config/index'
import { withRouter } from 'react-router-dom'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import * as service from '../service'

const mapDispatchToProps = ({ auth, payment, common, booking, contact, services, accountsettings, paymentsGrowth }) => {
  return {
    ...auth,
    ...payment,
    ...common,
    ...booking,
    ...contact,
    ...services,
    ...accountsettings,
    getPaymentsStatusCard: paymentsGrowth.getPaymentsStatusCard,
    getPaymentsFirstTimeCards: paymentsGrowth.getPaymentsFirstTimeCards
  }
}

const mapStateToProps = ({ auth, payment, common, booking, contact, services, accountsettings, paymentsGrowth }) => {
  return {
    ...auth,
    ...payment,
    ...common,
    ...booking,
    ...contact,
    ...services,
    ...accountsettings,
    firstTimeActionCards: paymentsGrowth.actions,
    statusCard: paymentsGrowth.statusCard
  }
}

class CustomForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showForm: '',
      data: '',
      cardToken: '',
      capthceValue: '',
      apiStatus: '',
      feedbackDone: '',
      submitting: false,
      showIframe: false,
      merchantID: ''
    }
  }

  async componentDidMount () {
    const searchValue = this.props.location && this.props.location.search
    if (searchValue) {
      const idObj = urlParamsToObj(searchValue.replace('?', ''))
      const id = idObj.id
      if (id) {
        const payload = { 'form_uuid': id }
        let merchantID = await service.getStripeMerchantID(payload)
        merchantID = merchantID.merchant_id
        console.log('Merchant ID = ' + merchantID)
        this.setState({ merchantID: merchantID })
        await this.props.fetchCustomPAymentFormData(id)
        if (this.props.customFormData) {
          this.setState({
            data: this.props.customFormData.data,
            showForm: 'show'
          })
        } else {
          this.setState({ showForm: 'notShow' })
        }
      } else {
        this.setState({ showForm: 'notShow' })
      }
    } else {
      this.setState({ showForm: 'notShow' })
    }
  }

  addingFormDataDynamic (val, values, setFieldValue, name) {
    const addDat = values.additionalData
    addDat[name] = val

    setFieldValue('additionalData', addDat)
  }
  addingFormDataDynamicSelect (val, values, setFieldValue, name, optArray) {
    const selected = optArray.filter((item) => item._id === val)
    const addDat = values.additionalData
    addDat[name] = selected[0]

    setFieldValue('additionalData', addDat)
  }

  async handleSubmit (val) {
    if (val === 'Error') {
      this.setState({ apiStatus: 'Error' })
    } else {
      this.setState({ apiStatus: 'Success' })
    }
  }

  async handleFeedBack (rating) {
    this.setState({ feedbackDone: true })
    const data = {
      pid: this.props.payNowData.data._id,
      name: this.props.payNowData.data.form_data.name,
      rating: rating,
      ismail: false,
      isWidget: true
    }
    await this.props.sendPaymentSuccessFeedback(data)
  }

  render () {
    const stripePayment = this.state.data && this.state.data.payment_type === 'stripe'
    const stripePromise = loadStripe(config.stripe_pk, { stripeAccount: this.state.merchantID })
    console.log('Is stripe payment = ' + stripePayment)
    return this.state.showForm ? (
      this.state.showForm === 'show' ? (
        !this.state.apiStatus ? (stripePayment

          ? <Elements stripe={stripePromise}><StripeWidget
            showForm={this.state.showForm}
            merchantID={this.state.merchantID}
            data={this.props.customFormData.data}
            createStripeWidgetTransaction={this.props.createStripeWidgetTransaction}
            paynowError={this.props.paynowError}
            apiStatus={this.state.apiStatus}
            onSubmit={this.handleSubmit.bind(this)}
          />
          </Elements> : <CardConnectWidget
            showForm={this.state.showForm}
            data={this.props.customFormData.data}
            apiStatus={this.state.apiStatus}
            onSubmit={this.handleSubmit.bind(this)}
          />
        ) : this.state.apiStatus === 'Success' ? (
          <div style={{ backgroundColor: this.state.data.settings && this.state.data.settings.form_bg_color }}>
            <div
              className={`${styles['payment-widget-response-wrapper']} p-15 text-center mx-auto d-flex align-items-center`}>
              <div>
                <header className={` mb-25 ${styles['response-header']}`}>
                  <figure className={`mb-10 mx-auto ${styles['response-icon']}`}>
                    {' '}
                    <img src="https://dufzo4epsnvlh.cloudfront.net/image/signup/checked.png" alt="" />{' '}
                  </figure>
                  <h4 className={styles['title']}>Successful</h4>
                </header>
                <div className={styles['response-content']}>
                  {this.props.payNowData && this.props.payNowData.data && this.props.payNowData.data.orderid ? (
                    <p className={styles['para']}>
                    Great, your transaction went through successfully.
                      <br />
                    Thank you for choosing us. Use this order number{' '}
                      <strong>{this.props.payNowData.data.orderid}</strong> in all communication
                    with us.
                    </p>) : null}
                </div>
                {this.props && this.props.payNowData && this.props.payNowData.feedback && (
                  <footer className={`text-center mx-auto ${styles['response-footer']}`}>
                    {!this.state.feedbackDone && (
                      <div className="d-flex justify-content-between">
                        <span className={styles['footer-range']}>Unlikely</span>
                        <span className={styles['footer-range']}>Very Likely</span>
                      </div>
                    )}
                    {!this.state.feedbackDone && (
                      <div>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item, index) => (
                          <button
                            key={index}
                            onClick={() => this.handleFeedBack(item)}
                            className={`btn p-0 mb-5 text-center ${styles['btn-range']}`}>
                            {item}
                          </button>
                        ))}
                      </div>
                    )}
                    {this.state.feedbackDone && (
                      <div>
                        {<p className={`btn p-0 mb-5 text-center ${styles['para']}`}>Thanks for your feedback</p>}
                      </div>
                    )}
                  </footer>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div style={{ backgroundColor: this.state.data.settings && this.state.data.settings.form_bg_color }}>
            <div
              className={`${styles['payment-widget-response-wrapper']} p-15 text-center justify-content-center mx-auto d-flex align-items-center`}>
              <div>
                <header className={` mb-25 ${styles['response-header']}`}>
                  <figure className={`mb-10 mx-auto ${styles['response-icon']}`}>
                    {' '}
                    <img src="https://dufzo4epsnvlh.cloudfront.net/image/signup/close.png" alt="" />{' '}
                  </figure>
                  <h4 className={styles['title']}>{`Your payment of $${this.state.data.amount} was declined.`}</h4>
                </header>
                <div className={styles['response-content']}>
                  <p className={styles['para']}>{this.props.paynowError}</p>
                </div>
                <footer className={`text-center mx-auto ${styles['response-footer']}`}>
                  <div className="d-flex justify-content-between">
                    <p> </p>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        )
      ) : (
        <div>Service not available</div>
      )
    ) : null
  }
}

export default compose(withElements({
  key: config.stripe_pk
}), withRouter, connect(mapStateToProps, mapDispatchToProps))(CustomForm)
